import { Component, inject } from '@angular/core';
import { FormGroup, FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@Component({
	selector: 'nta-add-user',
	templateUrl: './add-user.dialog.html',
	styleUrls: ['./add-user.dialog.scss'],
	imports: [
		MatDialogModule,
		FormsModule,
		MatFormFieldModule,
		MatInputModule,
		MatButtonModule,
	]
})
export class AddUserDialog {
	private dialogRef = inject<MatDialogRef<AddUserDialog>>(MatDialogRef);

	submit(addUserForm: FormGroup) {
		if (addUserForm.valid) {
			this.dialogRef.close({ ...addUserForm.value });
		}
	}
}
